import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
// import { register } from './serviceWorkerRegistration';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<App />);

// register({
//   onSuccess: () => console.log('Service Worker: Registered (offline ready)'),
//   onUpdate: () => {
//     console.log('New content available; please refresh.');
//     if (window.confirm('New version available! Update now?')) {
//       window.location.reload();
//     }
//   },
// });
